// extracted by mini-css-extract-plugin
export var productImage = "_n3-1";
export var viewLink = "_n3-2";
export var wishlistItem = "_n3-0";